import PropTypes from 'prop-types';
import cn from 'classnames';
import { forwardRef } from 'react';

import Controlled from './Controlled.jsx';
import Uncontrolled from './Uncontrolled.jsx';

const LdsSwitch = forwardRef(function LdsSwitch({
  id,
  name,
  value = null,
  onByDefault = null,
  required = false,
  label,
  disabled = false,
  labelPlacement = 'left',
  className,
  wrapperAttributes,
  labelAttributes,
  ariaLabelledby,
  onChange = null,
  checked = null,
  ...rest
}, ref) {
  function toggleSwitch(e) {
    if (onByDefault !== null) {
      const isChecked = e.currentTarget.checked;
      e.currentTarget.setAttribute('aria-checked', isChecked);
    }
    if (onChange) onChange(e);
  }

  return (
    <div
      className={cn(
        'lds-switch lds-form-field',
        {
          disabled,
        },
        className
      )}
      {...wrapperAttributes}
    >
      <label
        htmlFor={id}
        className="lds-switch-label"
        {...labelAttributes}
      >
        {labelPlacement !== 'right' && label}
        { checked !== null && onChange
          && <Controlled
            ref={ref}
            id={id}
            aria-labelledby={ariaLabelledby || id}
            name={name || id}
            disabled={disabled}
            required={required}
            aria-required={required || null}
            checked={checked}
            onChange={onChange}
          {...rest}
          />}
        { checked === null && !onChange
          && <Uncontrolled
            ref={ref}
            id={id}
            aria-labelledby={ariaLabelledby || id}
            name={name || id}
            disabled={disabled}
            required={required}
            aria-required={required || null}
            value={value}
            onByDefault={onByDefault}
            toggleSwitch={toggleSwitch}
            {...rest}
          />}
        <span aria-hidden="true" className={`lds-switch-toggle ${labelPlacement === 'right' ? 'lds-switch-label-right' : ''}`} >
          <span className="lds-switch-toggle-knob"></span>
        </span>
        {labelPlacement === 'right' && label}
      </label>
    </div>
  );
});

LdsSwitch.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  value: PropTypes.string,
  onByDefault: PropTypes.bool,
  required: PropTypes.bool,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  labelPlacement: PropTypes.oneOf(['left', 'right']),
  wrapperAttributes: PropTypes.object,
  labelAttributes: PropTypes.object,
};

export default LdsSwitch;
